
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 46 34","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"2"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M7.629 22.139a3.816 3.816 0 013.814-3.816 3.816 3.816 0 010 7.632 3.816 3.816 0 01-3.814-3.816","fill":"#78be14"}}),_c('path',{attrs:{"d":"M28.732 15.273L23.28 7.632h-3.45v16.786h3.726V14.134l5.108 7.114 5.082-7.174v10.344h3.726V7.632h-3.381l-5.359 7.641z"}})])])
          )
        }
      }
    